import { render, staticRenderFns } from "./TestingApprovalComments.vue?vue&type=template&id=6d539bd7"
import script from "./TestingApprovalComments.vue?vue&type=script&lang=ts"
export * from "./TestingApprovalComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports